export enum Situation {
	None = -1,
	Single = 0,
	Married = 1,
	Divorced = 2,
	Widowed = 3,
	FreeUnion = 4,
	Pacs = 5
}